import React from "react";
import { graphql } from "gatsby";
import { StaffDirectory } from "./StaffDirectory";
import {
  KontentComponentSettings,
  KontentLinkedDataStaffMember,
  KontentMultiChoice,
  StringValue,
} from "../../../types";
import { getMultiChoice } from "../../../lib/multichoice";
import { parseStaffMember } from "./StaffMember";

interface Props extends KontentComponentSettings {
  staff_members: KontentLinkedDataStaffMember;
  subhead: StringValue;
  show_images: KontentMultiChoice<"yes" | "no">;
  custom_sorting: KontentMultiChoice<"yes" | "no">;
}

const StaffDirectoryContainer: React.FC<Props> = ({
  subhead,
  id,
  component_settings__anchor_name,
  component_settings__hide_on_mobile,
  staff_members,
  show_images,
  custom_sorting,
}) => {
  const formatStaffMembers = () => {
    return staff_members.value.map(parseStaffMember).sort((a, b) => {
      if (a.lastName < b.lastName) {
        return -1;
      }

      if (a.lastName > b.lastName) {
        return 1;
      }

      if (a.lastName === b.lastName && a.firstName < b.firstName) {
        return -1;
      }

      if (a.lastName === b.lastName && a.firstName > b.firstName) {
        return 1;
      }

      return 0;
    });
  };
  const staffMembers =
    getMultiChoice(custom_sorting) === "yes"
      ? staff_members.value.map(parseStaffMember)
      : formatStaffMembers();
  const showImages = getMultiChoice(show_images) === "yes";

  return (
    <StaffDirectory
      subhead={subhead.value}
      staffMembers={staffMembers}
      id={id}
      anchor={component_settings__anchor_name.value}
      hideOnMobile={
        getMultiChoice(component_settings__hide_on_mobile) === "yes"
      }
      showImages={showImages}
    ></StaffDirectory>
  );
};

export default StaffDirectoryContainer;

export const fragmentStaffDirectory = graphql`
  fragment StaffDirectory on kontent_item_component___staff_directory {
    elements {
      component_settings__anchor_name {
        value
      }
      component_settings__hide_on_mobile {
        value {
          codename
        }
      }
      staff_members {
        ...kontentStaffMember
      }
      subhead {
        value
      }
      show_images {
        value {
          codename
        }
      }
      custom_sorting {
        value {
          codename
        }
      }
    }
  }
`;
